export const FILTER_KEY = "filters";
const FILTER_SEPARATOR = ",";
const FILTER_CODE_SEPARATOR = ":";
const FILTER_OPTION_SEPARATOR = "|";

export function decodeFilters(data: string) {
	const items: Record<string, string[]> = {};
	const filters = data.split(FILTER_SEPARATOR);

	for (const filter of filters.filter(Boolean)) {
		const [name, optionString] = filter.split(FILTER_CODE_SEPARATOR);
		const options = optionString?.split(FILTER_OPTION_SEPARATOR);

		if (name) Object.assign(items, { [name]: options });
	}

	return items;
}

export function encodeFilters(aggregations: Record<string, string[]>) {
	const filters = Object.entries(aggregations)
		.filter(([_name, options]) => options.length)
		.map(([name, options]) =>
			[name, options.join(FILTER_OPTION_SEPARATOR)].join(FILTER_CODE_SEPARATOR),
		)
		.join(FILTER_SEPARATOR);

	return filters;
}
